module.exports = __webpack_public_path__ + "img/Deletesaina.c2666561.svg";